export default __webpack_public_path__ + "static/media/react-native.c60bc3bc.png";